import Img from 'gatsby-image'
import React from 'react'
import { Container, Grid } from 'semantic-ui-react'

import * as styles from './section.module.sass' // eslint-disable-line no-restricted-imports

const Section = ({
  backgroundImage = undefined,
  backgroundColor = undefined,
  background = undefined,
  children,
  noPaddingTop = undefined,
  noPaddingBottom = undefined,
  paddingSize = '96px',

  round = undefined,
  fluid = undefined,
  ...props
}) => {
  const backgroundProps = background ? { background } : {}
  const style = {
    backgroundImage: backgroundImage ? `url(${backgroundImage})` : 'none',
    backgroundColor: backgroundColor || 'transparent',
    borderRadius: round ? '8px' : '0',
    ...backgroundProps,
  }

  return (
    <div style={style} className={styles.background}>
      {fluid && (
        <Img
          fluid={fluid}
          style={{
            position: 'absolute',
            left: 0,
            top: 0,
            width: '100%',
            height: '100%',
            zIndex: -1,
          }}
        />
      )}
      <div
        className={styles.filter}
        style={{
          paddingTop: noPaddingTop ? '0' : paddingSize,
          paddingBottom: noPaddingBottom ? '0' : paddingSize,
        }}
      >
        <Container>
          <Grid {...props}>{children}</Grid>
        </Container>
      </div>
    </div>
  )
}

export { Section }
